import { makeStyles } from '@material-ui/core/styles';
import { MOBILE_BREAKPOINT } from '../../../../config/constants';

export const useStyles = makeStyles(theme => ({
    day: {
        lineHeight: 1,
        marginLeft: 6,
        color: 'black',
        fontWeight: 600,
        display: 'inline',
        textAlign: 'center',
        [theme.breakpoints.up(MOBILE_BREAKPOINT)]: {
            fontSize: '50px',
        },
        [theme.breakpoints.down(MOBILE_BREAKPOINT)]: {
            fontSize: '30px',
        },
    },
    month: {
        fontSize: 22,
        color: theme.palette.primary.main,
        marginLeft: 7,
        fontWeight: 600,
        display: 'inline',
        textAlign: 'center',
    },
}));
